'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "PageActions": "Polaris-PageActions"
};

exports.default = styles;
